import React, { useEffect, useState } from "react";
import axiosInstance from "../../../../axios";
import { Loading } from "../../../Other/Loading";
import { useNavigate } from "react-router-dom";
import { FaBookOpen, FaVideo, FaComments, FaAward } from "react-icons/fa";

const StudentListData = () => {
  const [studentData, setStudentData] = useState();
  const [getFetchStatus, setGetFetchStatus] = useState(true);
  const [hoveredCard, setHoveredCard] = useState(null);
  const navigate = useNavigate();

  const fetch = async () => {
    try {
      const res = await axiosInstance.get("/student/statistics");
      setStudentData(res?.data?.data);
    } catch (error) {
      console.error("Error fetching student statistics:", error);
    } finally {
      setGetFetchStatus(false);
    }
  };

  useEffect(() => {
    fetch();
  }, []);

  const cards = [
    {
      title: "Enrolled Courses",
      value: studentData?.enrolledCourse || 0,
      thisMonth: studentData?.thisMonthEnrolledCourse || 0,
      icon: <FaBookOpen size={24} style={{ color: "#3b82f6" }} />,
      bgColor: "linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)",
      accentColor: "#3b82f6",
      action: "/dashboard/course/list",
    },
    {
      title: "Completed Webinars",
      value: studentData?.completedWebinars || 0,
      thisMonth: studentData?.thisMonthCompletedWebinars || 0,
      icon: <FaVideo size={24} style={{ color: "#10b981" }} />,
      bgColor: "linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%)",
      accentColor: "#10b981",
      action: "/dashboard/webinars/list",
    },
    {
      title: "Forum Count",
      value: studentData?.forumQuestions || 0,
      thisMonth: studentData?.thisMonthForumQuestions || 0,
      icon: <FaComments size={24} style={{ color: "#f59e0b" }} />,
      bgColor: "linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%)",
      accentColor: "#f59e0b",
      action: "/dashboard/student/forum",
    },
    {
      title: "Certificates",
      value: studentData?.certificates || 0,
      thisMonth: studentData?.thisMonthCertificates || 0,
      icon: <FaAward size={24} style={{ color: "#ec4899" }} />,
      bgColor: "linear-gradient(135deg, #fdf2f8 0%, #fce7f3 100%)",
      accentColor: "#ec4899",
      action: "/dashboard/student/awards",
    },
  ];

  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: "20px",
        marginBottom: "30px",
        fontFamily: "'Outfit', sans-serif",
      }}
    >
      {cards.map((card, index) => (
        <div
          key={index}
          onClick={() => navigate(card.action)}
          onMouseEnter={() => setHoveredCard(index)}
          onMouseLeave={() => setHoveredCard(null)}
          style={{
            flex: "1 1 calc(25% - 20px)",
            minWidth: "220px",
            padding: "24px",
            borderRadius: "20px",
            background: "white",
            border: "1px solid rgba(226, 232, 240, 0.8)",
            boxShadow: hoveredCard === index 
              ? "0 12px 30px rgba(0, 0, 0, 0.08)" 
              : "0 4px 18px rgba(0, 0, 0, 0.03)",
            transform: hoveredCard === index ? "translateY(-6px)" : "none",
            transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
            cursor: "pointer",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            position: "relative",
            overflow: "hidden",
          }}
        >
          {/* Accent Glow Background */}
          <div
            style={{
              position: "absolute",
              top: "-20px",
              right: "-20px",
              width: "80px",
              height: "80px",
              borderRadius: "50%",
              background: card.bgColor,
              opacity: 0.7,
              zIndex: 1,
              transition: "transform 0.5s ease",
              transform: hoveredCard === index ? "scale(1.8)" : "scale(1)",
            }}
          />

          <div style={{ position: "relative", zIndex: 2, display: "flex", justifyContent: "space-between", alignItems: "start" }}>
            <div>
              <p style={{ margin: 0, fontSize: "14px", fontWeight: "700", color: "#64748b", textTransform: "uppercase", tracking: "0.05em" }}>
                {card.title}
              </p>
              <h2 style={{ margin: "12px 0 0 0", fontSize: "36px", fontWeight: "800", color: "#0f172a", lineHeight: "1", display: "flex", alignItems: "center" }}>
                {getFetchStatus ? (
                  <span className="skeleton" style={{ width: "80px", height: "36px", borderRadius: "8px" }}></span>
                ) : (
                  card.value
                )}
              </h2>
            </div>
            <div style={{ padding: "10px", borderRadius: "12px", background: "white", boxShadow: "0 2px 10px rgba(0,0,0,0.04)" }}>
              {card.icon}
            </div>
          </div>

          <div
            style={{
              position: "relative",
              zIndex: 2,
              marginTop: "20px",
              paddingTop: "14px",
              borderTop: "1px solid #f1f5f9",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <span style={{ fontSize: "12px", color: "#94a3b8", fontWeight: "600" }}>This Month</span>
            {getFetchStatus ? (
              <span className="skeleton" style={{ width: "40px", height: "18px", borderRadius: "10px" }}></span>
            ) : (
              <span
                style={{
                  fontSize: "13px",
                  fontWeight: "700",
                  color: card.accentColor,
                  background: card.bgColor,
                  padding: "2px 10px",
                  borderRadius: "20px",
                }}
              >
                +{card.thisMonth}
              </span>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default StudentListData;
